import { ResetPassword } from './../../../../node_modules/yf-commerce-model-ui-lib/src/models/resetpassword.model';
// angular import
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

// project import

import { AuthService, MessageService, SharedDataService } from 'elbuild-ui-lib-core';
import { BOUser } from '../../@core/models/user';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

  constructor(private shareddataservice: SharedDataService, private authservice: AuthService, private router: Router,
    private messageservice: MessageService, private http: HttpClient
  ) {


  }
  public get currentUserValue(): BOUser | null {
    // Access the current user value from the signal
    return this.shareddataservice.loggeduser as BOUser;
  }


  public get currentUserName(): string | null {
    const currentUser = this.shareddataservice.loggeduser;
    return currentUser ? currentUser.fullname : null;
  }

  public resetPassword(email: string): Observable<any>{
      return this.authservice.resetPassword(email, 'access');
  }

  public validateResetPasswordToken(token: string): Observable<ResetPassword>{
    return this.http.get<ResetPassword>(environment.proxy+'access/resetform/'+token);
  }

  public setNewPassword(eid: number, newPsw: string, tkn: string){
    return this.http.post(environment.proxy+'access/'+eid+'/password', {password: newPsw, token: tkn});
  }



  isLoggedIn() {
    return this.shareddataservice.loggeduser !== undefined && this.shareddataservice.loggeduser !== null;
  }

  logout() {
    this.authservice.asynclogout().subscribe({
      next: () => {
        this.router.navigateByUrl('/login');
      },
      error: (err: any) => {
        console.error(err);
        this.messageservice.sendError(err);
      }
    });
  }
}
